import * as React from 'react';
import { Container, Row, Col } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPodcast } from '@fortawesome/free-solid-svg-icons';
import { stat } from 'fs';

import 'react-notifications-component/dist/theme.css';

import UserList from "./userList";
import UserDetail from "./userDetail";
import { Capitalize, showAlert } from "../common/functions";
import { getIsAdminLogged, getLoggedUserId } from '../../services/selectors/Accounts';

class UserPageComponent extends React.Component {
	state =
	{
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: -1,
		title: "",
		code: ""
	}

	constructor(props: any)
	{
		super(props);
		this.state = {
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: -1,
		title: "",
		code: ""
		}

		this.handleCallBackMethod = this.handleCallBackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search))?.get("page");
		var tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);
		var codestr = (new URLSearchParams(window.location.search)).get("code");
		var codeValue = codestr === null ? "" : codestr;

		var pageValue = (id >= 0 || (codeValue && codeValue !== '')) ? "detail" : tValue;

		var userId = getLoggedUserId()
		if (!getIsAdminLogged() && userId != undefined && userId != id) {
			window.location.href="/401"
		}

		this.setState({
			...stat,
			page: pageValue,
			id: id,
			code: codeValue,
			isView: pageValue === "" ? true : false
		});

		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}

		document.title = `${pageValue==="" ? "Users" : "User"} - Daily Audio Bible Administration`;
	}


	handleCallBackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		var isAdminLogged = getIsAdminLogged();
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page === "add" && isAdminLogged &&(
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="usersPageTitle"> Users - Create New</span>
									</h2>
									<hr />
									<UserDetail callback={this.handleCallBackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page === "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="usersPageTitle"> Users - {Capitalize(title)} Details</span>
									</h2>
									<hr />
									<UserDetail callback={this.handleCallBackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page === "" && this.state.isView && isAdminLogged && (<div>
								<h2>
									<FontAwesomeIcon icon={faPodcast} />
									<span data-testid="usersPageTitle"> Users</span>
								</h2>
								<hr />
								<UserList />
							</div>)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}



export default UserPageComponent;